import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import './styles/index.css';
import Example from './example';
import UserManagementProvider from './context/userManagementContext';
import AppContext from './context/appContext';
// import Chat from './components/chat';

function init(config: any) {
  if (config.el && config.render) {
    render({elementId: config.el, config})
  }
}

function render({elementId, config}: any) {
  const widgetContainer = ReactDOM.createRoot(document.getElementById(elementId));
  const render = config.render;
  
  widgetContainer.render(
    <React.StrictMode>
      <UserManagementProvider config={config}>
        <AppContext config={config}>
          {/* {render.chat && <Chat />} */}
          {render.widget && <App />}
          {render.example && 
            <Example>
              <App />
            </Example>
          }
        </AppContext>
      </UserManagementProvider>
    </React.StrictMode>
  );
}

export default {
  init
}
